import { z } from 'zod/v4';
import { DocumentTypes } from '../../documents/index.js';
import { PerformedBySchema } from '../../performed-by/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
const inputSchema = z.object({
    documentId: z
        .uuid()
        .describe('The document to fetch. Obtain via search_documents or via search_case_history (refType=DOCUMENT, refId=documentId).'),
});
const outputSchema = z.object({
    documentId: z.uuid(),
    fileId: z.uuid(),
    fileName: z.string(),
    contentType: z.string(),
    type: z.enum(DocumentTypes),
    date: z.iso.datetime().nullable(),
    signedAt: z.iso.datetime().nullable(),
    isFoundation: z.boolean(),
    sizeBytes: z.number().int().nullable(),
    createdBy: PerformedBySchema.nullable(),
    amount: z.string().nullable(),
    note: z.string().nullable(),
});
export const getDocumentTool = {
    name: ToolName.GetDocument,
    category: ToolCategory.Documents,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: "Read a document's domain metadata (type, signed/foundation status, dates, optional amount and caseworker note). To read the document's text content, call get_file with the fileId returned here.",
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=get-document.js.map